export const LEVEL_OPTIONS = {
  tr: ["A1", "A2", "B1", "B2", "C1", "C2", "Başlangıç", "Orta", "İleri", "Anadil"],
  en: ["A1", "A2", "B1", "B2", "C1", "C2", "Beginner", "Intermediate", "Advanced", "Native"],
};

// Bilingual value helpers: value can be {tr, en} or a legacy plain string
export function bi(v, lang) {
  if (v && typeof v === "object") return v[lang] ?? "";
  return typeof v === "string" ? v : "";
}
export function setBi(v, lang, value) {
  const base = v && typeof v === "object" ? { ...v } : { tr: v || "", en: v || "" };
  base[lang] = value;
  return base;
}

export const KVKK = {
  tr: {
    title: "KVKK Aydınlatma Metni ve Açık Rıza",
    body:
      "Dual Study Abroad (\"Danışmanlık\") olarak, yurtdışı üniversite ve yüksek lisans başvurularınıza destek olmak amacıyla bu form aracılığıyla paylaştığınız kişisel verileriniz (kimlik, iletişim, eğitim, deneyim ve başvuruya ilişkin diğer bilgiler) 6698 sayılı Kişisel Verilerin Korunması Kanunu (\"KVKK\") kapsamında veri sorumlusu sıfatıyla işlenmektedir. Verileriniz; CV ve niyet/referans mektubu hazırlığı, başvuru süreçlerinin yürütülmesi ve sizinle iletişim amacıyla, ilgili mevzuata uygun şekilde saklanacaktır. Dilediğiniz zaman KVKK'nın 11. maddesindeki haklarınızı kullanarak verilerinize erişebilir, düzeltilmesini veya silinmesini talep edebilirsiniz.",
    form: "Bu formu göndererek yukarıdaki kişisel verilerimin belirtilen amaçlarla işlenmesine açık rıza veriyorum.",
    share: "CV ve başvuru belgelerimin, başvuru yapılacak üniversite/kurum ve ilgili resmi mercilerle paylaşılmasına açık rıza veriyorum.",
  },
  en: {
    title: "Data Protection Notice & Explicit Consent",
    body:
      "Dual Study Abroad (the \"Consultancy\") processes the personal data you share via this form (identity, contact, education, experience and other application-related information) as data controller under applicable data-protection law (Turkey's KVKK Law No. 6698) in order to support your university and graduate applications abroad. Your data is used to prepare your CV and personal/reference statements, run your application processes and communicate with you, and is stored in accordance with the relevant legislation. You may at any time exercise your rights (access, rectification, erasure) regarding your data.",
    form: "By submitting this form, I give my explicit consent to the processing of my personal data above for the stated purposes.",
    share: "I give my explicit consent to share my CV and application documents with the target universities/institutions and relevant official authorities.",
  },
};

export const STATEMENT = {
  tr: {
    title: "Niyet Mektubu Taslağı",
    intro: "CV verilerinizden ve danışman yorumlarınızdan, hedef programınıza uygun bir niyet (motivasyon) mektubu taslağı üretiriz. Taslak, UCAS'ın üç sorusuna göre yapılandırılır.",
    disclaimer: "Bu taslak yalnızca fikir vermek amaçlıdır. Orijinal niyet mektubu öğrencinin kendisi tarafından, kendi ifadeleriyle yazılmalı ve UCAS'ın üç sorusuna toplam en fazla 4.000 karakterde cevap vermelidir. Köşeli parantez içindeki [boşlukları] kendi somut örneklerinizle doldurun.",
    guideTitle: "Mini Rehber: UCAS'ın 3 Sorusu",
    university: "Hedef Üniversite/ler",
    universityPh: "Örn. University of Manchester, KCL",
    programs: "Hedef Bölüm/ler",
    programsPh: "Örn. Computer Science, Data Science",
    country: "Ülke (isteğe bağlı)",
    shortTitle: "UCAS Sorularına Kısa Cevaplarınız",
    shortDesc: "Hedef üniversite ve bölümleriniz için aşağıdaki üç soruya kendi cümlelerinizle kısaca cevap verin (2-4 cümle yeterli). Taslak, bu cevaplar ve CV'niz üzerinden üretilir.",
    shortPh: "Kısaca belirtin...",
    pledge: "Üretilen taslağı olduğu gibi kullanmayacağımı; yalnızca fikir almak ve üzerinde çalışmak amacıyla kullanacağımı, niyet/motivasyon mektubumu kendi ifade ve cümlelerimle yazacağımı taahhüt ediyorum.",
    pledgeRequired: "Taslak üretmek için taahhüt kutusunu işaretleyin.",
    draftBanner: "Bu taslak SADECE FİKİR VERME AMAÇLIDIR. Başvuru yapan öğrenci motivasyon mektubunu kendi ifade ve cümleleriyle yazmalıdır.",
    motivation: "Bu programı neden istiyorsun / kariyer hedefin? (isteğe bağlı)",
    motivationPh: "Kendi cümlelerinle: seni bu alana çeken şey, gelecekte ne yapmak istediğin...",
    generate: "Taslak Üret",
    regenerate: "Yeniden Üret",
    generating: "Taslak hazırlanıyor... (20-40 sn)",
    generated: "Taslak hazır. Metni kendi ifadelerinizle düzenleyin.",
    fallback: "AI şu an yanıt vermedi; doldurmanız için bir şablon yerleştirildi.",
    total: "Toplam",
    chars: "karakter",
    over: "UCAS sınırı olan 4.000 karakteri aşıyorsunuz.",
    suggested: "Önerilen",
    pdfNote: "Taslak, CV PDF'inin sonuna ek sayfa olarak eklenir.",
    confirmRegen: "Mevcut taslak bu dilde üzerine yazılacak. Devam edilsin mi?",
    questions: [
      { q: "1. Akademik Motivasyon", en: "Why do you want to study this course or subject?", tr: "Bu bölümü veya konuyu neden okumak istiyorsunuz?", what: "Bölüme karşı ilginizi, tutkunuzu ve akademik merakınızı tetikleyen unsurları açıklayın.", tip: "\"Çocukluğumdan beri bu konuya hayranım\" gibi klişelerden kaçının. Sizi etkileyen spesifik bir makale, kitap, teorisyen, konferans veya güncel bir sektör probleminden bahsedin.", len: "≈ 1.000 – 1.200 karakter", min: 1000, max: 1200 },
      { q: "2. Akademik Hazırlık", en: "How have your qualifications and studies helped you to prepare for this course or subject?", tr: "Aldığınız eğitimler ve nitelikleriniz bu bölüme hazırlanmanıza nasıl yardımcı oldu?", what: "Mevcut okul eğitiminizin (A-Level, IB, MEB vb.) size kazandırdığı akademik becerileri gösterin.", tip: "Sadece dersleri listelemeyin. Bir dönem projesini, akademik yarışmayı veya müfredat dışı derinlemesine okumalarınızı (super-curricular) eleştirel analiz yeteneğinizi vurgulayarak anlatın.", len: "≈ 1.500 – 1.800 karakter (en ağırlıklı bölüm)", min: 1500, max: 1800 },
      { q: "3. Eğitim Dışı Hazırlık ve Deneyimler", en: "What else have you done to prepare outside of education, and why are these experiences useful?", tr: "Eğitim dışında hazırlanmak için başka neler yaptınız ve bu deneyimler neden yararlı?", what: "Stajlar, gönüllülük, yarı zamanlı işler, spor/sanat veya liderlik rolleri gibi okul dışı aktivitelerinizi ekleyin.", tip: "Önemli olan aktivitenin kendisi değil, kazandırdığı transfer edilebilir beceriler (zaman yönetimi, takım çalışması, problem çözme) ve bunların üniversitede size nasıl yardımcı olacağıdır.", len: "≈ 500 – 800 karakter", min: 500, max: 800 },
    ],
  },
  en: {
    title: "Personal Statement Draft",
    intro: "We generate a personal (motivation) statement draft tailored to your target program from your CV data and advisor comments, structured around UCAS's three questions.",
    disclaimer: "This draft is for inspiration only. The original personal statement must be written by the student in their own words, answering UCAS's three questions within 4,000 characters in total. Fill the [bracketed gaps] with your own concrete examples.",
    guideTitle: "Mini Guide: UCAS's 3 Questions",
    university: "Target University/ies",
    universityPh: "e.g. University of Manchester, KCL",
    programs: "Target Programme(s)",
    programsPh: "e.g. Computer Science, Data Science",
    country: "Country (optional)",
    shortTitle: "Your Short Answers to the UCAS Questions",
    shortDesc: "For your target universities and programmes, briefly answer the three questions in your own words (2-4 sentences each). The draft is generated from these answers and your CV.",
    shortPh: "Briefly describe...",
    pledge: "I undertake not to use the generated draft as-is; I will use it only for ideas and as a working base, and I will write my personal statement in my own words and sentences.",
    pledgeRequired: "Tick the pledge box to generate a draft.",
    draftBanner: "This draft is FOR IDEAS ONLY. The applicant must write the personal statement in their own words and sentences.",
    motivation: "Why do you want this program / your career goal? (optional)",
    motivationPh: "In your own words: what draws you to this field, what you want to do in the future...",
    generate: "Generate Draft",
    regenerate: "Regenerate",
    generating: "Preparing draft... (20-40 s)",
    generated: "Draft ready. Edit the text in your own words.",
    fallback: "AI did not respond; a template has been inserted for you to complete.",
    total: "Total",
    chars: "characters",
    over: "You exceed the UCAS limit of 4,000 characters.",
    suggested: "Suggested",
    pdfNote: "The draft is appended to the CV PDF as an extra page.",
    confirmRegen: "The current draft in this language will be overwritten. Continue?",
    questions: [
      { q: "1. Academic Motivation", en: "Why do you want to study this course or subject?", tr: "", what: "Explain what sparked your interest, enthusiasm and academic curiosity for the subject.", tip: "Avoid clichés like \"I have been fascinated since childhood\". Mention a specific paper, book, theorist, conference or a current industry problem that influenced you.", len: "≈ 1,000 – 1,200 characters", min: 1000, max: 1200 },
      { q: "2. Academic Preparation", en: "How have your qualifications and studies helped you to prepare for this course or subject?", tr: "", what: "Show the academic skills and knowledge your current education (A-Level, IB, national curriculum, etc.) has given you.", tip: "Don't just list courses. Describe a term project, an academic competition or super-curricular reading, highlighting critical analysis.", len: "≈ 1,500 – 1,800 characters (most weight)", min: 1500, max: 1800 },
      { q: "3. Preparation Outside Education", en: "What else have you done to prepare outside of education, and why are these experiences useful?", tr: "", what: "Include internships, volunteering, part-time jobs, sport/arts or leadership roles.", tip: "What matters is not the activity itself but the transferable skills (time management, teamwork, problem solving) and how they will help you at university.", len: "≈ 500 – 800 characters", min: 500, max: 800 },
    ],
  },
};

export const REFBRIEF = {
  tr: {
    title: "Referans Mektubu Notları (Brifing)",
    intro: "CV'nizden öne çıkan başarıları özetleyen, öğretmeninizin/danışmanınızın referans (tavsiye) mektubunda kullanabileceği bir brifing hazırlar. Bu metin öğretmenle paylaşılmak içindir; öğretmen kendi cümleleriyle mektubu yazar.",
    generate: "Brifing Oluştur",
    regenerate: "Yeniden Oluştur",
    generating: "Brifing hazırlanıyor... (15-30 sn)",
    placeholder: "Brifing burada görünecek. 'Brifing Oluştur'a tıklayın veya kendiniz düzenleyin.",
    copy: "Kopyala",
    copied: "Panoya kopyalandı",
    downloadPdf: "Brifing PDF indir",
    error: "AI şu an yanıt vermedi, tekrar deneyin.",
    label: "Brifing metni (düzenlenebilir)",
    empty: "Öğrenci henüz referans brifingi oluşturmadı.",
    forTeacher: "Öğretmene / referans veren kişiye özel not",
  },
  en: {
    title: "Reference Letter Notes (Briefing)",
    intro: "Prepares a briefing that summarises the standout achievements from your CV, which your teacher/advisor can use when writing a reference (recommendation) letter. This text is meant to be shared with the teacher; they write the letter in their own words.",
    generate: "Generate Briefing",
    regenerate: "Regenerate",
    generating: "Preparing briefing... (15-30 s)",
    placeholder: "The briefing will appear here. Click 'Generate Briefing' or write your own.",
    copy: "Copy",
    copied: "Copied to clipboard",
    downloadPdf: "Download briefing PDF",
    error: "AI did not respond, please try again.",
    label: "Briefing text (editable)",
    empty: "The student has not generated a reference briefing yet.",
    forTeacher: "Note for the teacher / referee",
  },
};


export function periodText(start, end) {
  if (start && !end) return { tr: `${start} – Devam ediyor`, en: `${start} – Present` };
  if (end && !start) return { tr: end, en: end };
  return { tr: `${start} – ${end}`, en: `${start} – ${end}` };
}

export const T = {
  tr: {
    appName: "Dual Study Abroad",
    tagline: "Yurtdışı Üniversite Başvuruları için Detaylı CV & Niyet Mektubu Veri Danışmanı",
    heroTitle: "Kendini eksiksiz anlat, en güçlü başvuruyu hazırla",
    heroDesc:
      "Soru-cevap yöntemiyle geçmiş deneyimlerini hiçbir başlığı atlamadan topluyoruz ve profesyonel, tablo formatında bir CV'ye dönüştürüyoruz.",
    start: "Hemen Başla",
    login: "Giriş Yap",
    register: "Kayıt Ol",
    logout: "Çıkış",
    dashboard: "CV'lerim",
    email: "E-posta",
    password: "Şifre",
    name: "Ad Soyad",
    loginTitle: "Hesabına giriş yap",
    registerTitle: "Yeni hesap oluştur",
    noAccount: "Hesabın yok mu? Kayıt ol",
    haveAccount: "Zaten hesabın var mı? Giriş yap",
    myCvs: "CV'lerim",
    newCv: "Yeni CV Oluştur",
    noCvs: "Henüz kaydedilmiş bir CV'niz yok. İlk CV'nizi oluşturun.",
    open: "Aç / Düzenle",
    delete: "Sil",
    updated: "Güncellendi",
    infoTitle: "Bu araç neden önemli?",
    infoNote:
      "Bu CV, üniversite ve yüksek lisans başvuruları için özel olarak hazırlanır. Verdiğiniz detaylı cevaplar; en başarılı niyet mektubu (personal statement) ve referans mektubu yazımı için gerekli ham veriyi oluşturur. Yüzeysel değil, somut ve anlatılabilir cevaplar verin — danışmanınız bu verilerle eksik alanları sizinle konuşabilir.",
    saving: "Kaydediliyor...",
    saved: "Kaydedildi",
    downloadPdf: "PDF İndir",
    cvTitle: "CV Başlığı",
    personalInfo: "Kişisel Bilgiler",
    fullName: "Ad Soyad",
    phone: "Telefon",
    location: "Konum (Şehir, Ülke)",
    birthDate: "Doğum Tarihi",
    nationality: "Uyruk",
    targetProgram: "Hedef Program / Bölüm",
    summary: "Kısa Özet (isteğe bağlı)",
    addRecord: "Kayıt Ekle",
    remove: "Kaldır",
    prev: "Önceki",
    next: "Sonraki",
    finish: "Bitir",
    step: "Adım",
    of: "/",
    livePreview: "Canlı Önizleme",
    editForm: "Formu Düzenle",
    aiDeepen: "AI ile Derinleştir",
    aiThinking: "Düşünüyor...",
    aiQuestions: "Takip Soruları",
    aiSuggestion: "Önerilen Yazım",
    useSuggestion: "Öneriyi Kullan",
    close: "Kapat",
    records: "kayıt",
    completed: "tamamlandı",
    academicCv: "AKADEMİK CV",
    contact: "İletişim",
    backToDashboard: "CV'lerime Dön",
    confirmDelete: "Bu CV'yi silmek istediğinize emin misiniz?",
    photo: "Fotoğraf",
    uploadPhoto: "Fotoğraf Yükle",
    changePhoto: "Değiştir",
    photoHint: "Vesikalık (JPG/PNG/WEBP, en fazla 5MB)",
    uploading: "Yükleniyor...",
    advisorNote: "Danışman Notu",
    advisorNotePh: "Bu kategori için danışman notu / eksik veya güçlendirilecek noktalar...",
    consentsTitle: "KVKK & İzinler",
    consentStepDesc: "Başvuru sürecine devam edebilmek için lütfen aşağıdaki onayları inceleyip işaretleyin.",
    pdfLangTitle: "Çıktı Dilini Seçin",
    pdfLangDesc: "CV'yi hangi dilde indirmek istersiniz? Aynı verilerle her iki dilde de üretilebilir.",
    downloadTr: "Türkçe İndir",
    downloadEn: "İngilizce İndir",
    dragHint: "Sıralamak için kartı sürükleyin",
    editingLang: "Düzenlenen dil",
    langSwitchHint: "Diğer dildeki metni girmek için sağ üstteki dil düğmesini kullanın.",
    consentRequired: "Devam etmek için form gönderim onayı gereklidir.",
    consentRequiredBoth: "PDF indirmek için KVKK açık rıza onaylarının ikisini de işaretlemeniz gerekir.",
    consentMandatory: "Bu onay zorunludur.",
    downloadBoth: "Her İkisini İndir (TR + EN)",
    shareLink: "Danışman Linki",
    shareTitle: "Danışman Görünümü Bağlantısı",
    shareDesc: "Bu bağlantıya sahip danışman, giriş yapmadan CV'nizi görüntüleyip her kategoriye yorum bırakabilir. Bağlantı kalıcıdır; sadece güvendiğiniz danışmanla paylaşın.",
    copy: "Kopyala",
    copied: "Bağlantı kopyalandı",
    advisorComments: "Danışman Yorumları",
    noComments: "Henüz yorum yok.",
    completion: "Tamamlanma",
    completionReady: "Harika! Tüm önemli alanlar dolu.",
    completionHint: "Güçlü bir başvuru için şu alanları da doldurmanızı öneririz:",
    cropTitle: "Fotoğrafı Kırp",
    cropDesc: "Vesikalık oranında (3:4) kırpın. Yüzünüz ortada ve net görünmeli.",
    zoom: "Yakınlaştır",
    cropSave: "Kırp ve Yükle",
    cancel: "İptal",
    goTo: "Git",
    statementStep: "Niyet Mektubu",
    deadlinesStep: "Başvuru Takvimi",
    duplicate: "Kopyala",
    duplicated: "CV kopyalandı",
    upcomingTitle: "Yaklaşan başvuru tarihleri",
    daysLeft: "gün kaldı",
    adminPanel: "Yönetici Paneli",
    approvalOk: "Danışman tarafından incelendi ve onaylandı",
    approvalStale: "Taslak yeniden üretildi; danışman onayı düştü, tekrar inceleme gerekiyor.",
    approvalNone: "Danışman henüz incelemedi. Danışman linkini paylaşarak inceleme isteyebilirsiniz.",
    translating: "Eksik çeviriler AI ile tamamlanıyor...",
    translatedN: "alan AI ile çevrildi. İndirmeden sonra Builder'da kontrol edebilirsiniz.",
    translateNote: "İndirmeden önce, seçilen dilde boş kalan alanlar (kazanımlar, açıklamalar vb.) AI ile otomatik çevrilir.",
    translateNow: "Eksik çevirileri şimdi tamamla",
    periodStart: "Başlangıç",
    periodEnd: "Bitiş",
    periodStartPh: "örn. 09/2021",
    periodEndPh: "örn. 06/2024 (boş = Devam ediyor)",
    ongoing: "Devam ediyor",
    unsavedWarn: "Kaydedilmemiş değişiklikler var.",
  },
  en: {
    appName: "Dual Study Abroad",
    tagline: "Detailed CV & Personal Statement Data Consultant for University Applications Abroad",
    heroTitle: "Tell your full story, build your strongest application",
    heroDesc:
      "Through a guided Q&A we capture every one of your past experiences — skipping no category — and turn them into a professional, table-format CV.",
    start: "Get Started",
    login: "Log In",
    register: "Sign Up",
    logout: "Log Out",
    dashboard: "My CVs",
    email: "Email",
    password: "Password",
    name: "Full Name",
    loginTitle: "Log in to your account",
    registerTitle: "Create a new account",
    noAccount: "No account? Sign up",
    haveAccount: "Already have an account? Log in",
    myCvs: "My CVs",
    newCv: "Create New CV",
    noCvs: "You have no saved CVs yet. Create your first one.",
    open: "Open / Edit",
    delete: "Delete",
    updated: "Updated",
    infoTitle: "Why does this matter?",
    infoNote:
      "This CV is prepared specifically for university and graduate applications. Your detailed answers become the raw material needed to write the most compelling personal statement and reference letters. Give concrete, describable answers — not shallow ones — so your advisor can review the gaps with you.",
    saving: "Saving...",
    saved: "Saved",
    downloadPdf: "Download PDF",
    cvTitle: "CV Title",
    personalInfo: "Personal Information",
    fullName: "Full Name",
    phone: "Phone",
    location: "Location (City, Country)",
    birthDate: "Date of Birth",
    nationality: "Nationality",
    targetProgram: "Target Program / Major",
    summary: "Short Summary (optional)",
    addRecord: "Add Record",
    remove: "Remove",
    prev: "Previous",
    next: "Next",
    finish: "Finish",
    step: "Step",
    of: "of",
    livePreview: "Live Preview",
    editForm: "Edit Form",
    aiDeepen: "Deepen with AI",
    aiThinking: "Thinking...",
    aiQuestions: "Follow-up Questions",
    aiSuggestion: "Suggested Wording",
    useSuggestion: "Use Suggestion",
    close: "Close",
    records: "records",
    completed: "completed",
    academicCv: "ACADEMIC CV",
    contact: "Contact",
    backToDashboard: "Back to My CVs",
    confirmDelete: "Are you sure you want to delete this CV?",
    photo: "Photo",
    uploadPhoto: "Upload Photo",
    changePhoto: "Change",
    photoHint: "Passport-style (JPG/PNG/WEBP, max 5MB)",
    uploading: "Uploading...",
    advisorNote: "Advisor Note",
    advisorNotePh: "Advisor note for this category / gaps or points to strengthen...",
    consentsTitle: "Data Protection & Consents",
    consentStepDesc: "To proceed with the application, please review and tick the consents below.",
    pdfLangTitle: "Choose Output Language",
    pdfLangDesc: "In which language would you like to download the CV? It can be produced in both from the same data.",
    downloadTr: "Download Turkish",
    downloadEn: "Download English",
    dragHint: "Drag a card to reorder",
    editingLang: "Editing language",
    langSwitchHint: "Use the language switch at the top right to enter the text in the other language.",
    consentRequired: "Form submission consent is required to proceed.",
    consentRequiredBoth: "You must tick both KVKK consent checkboxes before downloading the PDF.",
    consentMandatory: "This consent is mandatory.",
    downloadBoth: "Download Both (TR + EN)",
    shareLink: "Advisor Link",
    shareTitle: "Advisor View Link",
    shareDesc: "An advisor with this link can view your CV and leave comments on each category without logging in. The link is permanent; share it only with a trusted advisor.",
    copy: "Copy",
    copied: "Link copied",
    advisorComments: "Advisor Comments",
    noComments: "No comments yet.",
    completion: "Completion",
    completionReady: "Great! All key areas are filled in.",
    completionHint: "For a strong application we suggest completing these too:",
    cropTitle: "Crop Photo",
    cropDesc: "Crop to passport ratio (3:4). Your face should be centred and clear.",
    zoom: "Zoom",
    cropSave: "Crop & Upload",
    cancel: "Cancel",
    goTo: "Go",
    statementStep: "Personal Statement",
    deadlinesStep: "Application Calendar",
    duplicate: "Duplicate",
    duplicated: "CV duplicated",
    upcomingTitle: "Upcoming application deadlines",
    daysLeft: "days left",
    adminPanel: "Admin Panel",
    approvalOk: "Reviewed and approved by your advisor",
    approvalStale: "Draft was regenerated; advisor approval dropped, needs a new review.",
    approvalNone: "Not reviewed by an advisor yet. Share the advisor link to request a review.",
    translating: "Filling missing translations with AI...",
    translatedN: "fields translated by AI. Review them in the builder after download.",
    translateNote: "Before download, fields left empty in the selected language (achievements, descriptions, etc.) are translated automatically by AI.",
    translateNow: "Fill missing translations now",
    periodStart: "Start",
    periodEnd: "End",
    periodStartPh: "e.g. 09/2021",
    periodEndPh: "e.g. 06/2024 (empty = Present)",
    ongoing: "Present",
    unsavedWarn: "You have unsaved changes.",
  },
};
